const slider = () => {
  const sliders = document.querySelectorAll('.slider.swiper');
  if (!sliders.length) return;

  sliders.forEach(el => {
    new Swiper(el, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        992: {
          slidesPerView: 4,
        },
      },
    });
  });
};

export default slider;
